'use strict';

module Patersons {
    // This enum must be kept consistent with the C# enum defined in Patersons.Investors.InvestorApi.Model.
    // HACK: The quirk of casting "Value" to <any> before assigning it to the enum Value is necessary
    // because, when we deserialise the ReportType information from the Web API we get back a string, which
    // the transpiled Javascript happily assigns to the target property since it stores no type information.
    export enum ReportType {
        CapitalTransactions = <any>"CapitalTransactions",
        QuarterlyReports = <any>"QuarterlyReports",
        Cash = <any>"Cash",
        Income = <any>"Income",
        CapitalGains = <any>"CapitalGains",
        UnrealisedCapitalGains = <any>"UnrealisedCapitalGains",
        Performance = <any>"Performance",
        TaxReports = <any>"TaxReports",
        Valuation = <any>"Valuation",
        StandardLedger = <any>"StandardLedger",
        MarketValue = <any>"MarketValue"
    }

    export abstract class AbstractReport {
        accountNumber: string;
        adviser: string;
        title: string;
        asAtDate: Date;
        dateFrom: Date;
        dateTo: Date;
        creationDateUtc: Date;
        reportType: ReportType;
    }

    export abstract class AbstractReportController {
        shortPaddedDateFormat: string = 'dd MMM yyyy';
        mediumDateFormat: string = 'd MMMM yyyy';
        fullDateTimeFormat: string = 'd MMMM yyyy h:mm:ssa';
        mapAgilityExchangeCodeToMIC(exchangeCode){
            switch (exchangeCode) {

                case "HKE":
                case "HKG":
                    exchangeCode = "EX$$$$XHKG"
                    break;
                case "SGX":
                case "SES":
                    exchangeCode = "EX$$$$XSES"
                    break;
                case "NAS":
                    exchangeCode = "EX$$$$XNAS"
                    break;
                case "NYS":
                    exchangeCode = "EX$$$$XNYS"
                    break;
                case "AME":
                case "ASE":
                    exchangeCode = "EX$$$$XASE"
                    break;
                case "LSE":
                case "LON":
                    exchangeCode = "EX$$$$XLON"
                    break;
                case "ETR":
                case "FRA":
                    exchangeCode = "EX$$$$XFRA"
                    break;
                case "PAR":
                    exchangeCode = "EX$$$$XPAR"
                    break;
                case "ARC":
                case "ARCX":
                    exchangeCode = "EX$$$$ARCX"
                    break;
                case "AMS":
                    exchangeCode = "EX$$$$XAMS"
                    break;
                case "MAD":
                case "MCE":
                    exchangeCode = "EX$$$$XMCE"
                    break;
                case "MTA":
                case "MIL":
                    exchangeCode = "EX$$$$XMIL"
                    break;
                case "AXW":
                case "ASX":
                    exchangeCode = "EX$$$$XASX";
                    break;
                default:
                    exchangeCode = "UNL";
                    break;
            }
            return exchangeCode;
        }
    }
}
